// extracted by mini-css-extract-plugin
export default {"success":"Success_success__nbZao","icon":"Success_icon__QTaQJ","info":"Success_info__k093D","price":"Success_price__alLT2","text":"Success_text__Ox7hH"};